import React, { useEffect, useMemo, useState } from 'react';
import { useData } from '../data/DataProvider';
import { usePortalClient } from './usePortalClient';
import EmptyState from '../shared/components/EmptyState';
import KeyDateList from '../shared/components/KeyDateList';
import Skeleton from '../shared/components/Skeleton';
import PortalHeader from './PortalHeader';

export default function KeyDates() {
  const { data } = useData();
  const { client } = usePortalClient();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 180);
    return () => clearTimeout(timer);
  }, []);

  const keyDates = useMemo(
    () => data.keyDates
      .filter((item) => item.client_id === client.id)
      .sort((a, b) => new Date(a.date) - new Date(b.date)),
    [client.id, data.keyDates]
  );

  if (loading) {
    return <Skeleton rows={4} />;
  }

  return (
    <>
      <PortalHeader
        eyebrow="Your schedule"
        title="Key dates"
        description="Appointments, renewals, and maintenance reminders."
      />

      {keyDates.length ? (
        <section className="portal-card no-padding">
          <KeyDateList dates={keyDates} />
        </section>
      ) : (
        <EmptyState title="No key dates yet" message="Your next appointments and reminders will appear here." />
      )}
    </>
  );
}